import React, { useContext, useMemo } from "react";
import RecruitmentConditionButton from "../molecules/RecruitmentConditionButton";
import RecruitmentList from "./RecruitmentList";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import BaseApi from "../../../../functions/axios";
import { recruitmentListContext } from "../../RecruitmentListPage";
import ProjectIdField from "../molecules/ProjectIdField";
import DateField from "../molecules/DateField";
import CostField from "../molecules/CostField";
import CostNotSetField from "../molecules/CostNotSetField";
import KeywordField from "../molecules/KeywordField";
import ClosedRecruitmentField from "../molecules/ClosedRecruitmentField";
import toISOStringWithTimezone from "../../../../functions/toISOStringWithTimezone";

const createDefaultFormData = () => {
  const currentDay = new Date();
  const lastMonthDay = new Date(
    currentDay.getFullYear(),
    currentDay.getMonth() - 1,
    1
  );
  return {
    keyword: "",
    project_id: "",
    date_from: toISOStringWithTimezone(lastMonthDay).split("T")[0],
    date_to: toISOStringWithTimezone(currentDay).split("T")[0],
    offset: 0,
    cost_not_set: false,
    cost_min: "",
    cost_max: "",
    close_check: 1,
  };
};

const inputAutofillStyle = {
  "& .MuiInputBase-input": {
    padding: "6px 5px 7px",
    WebkitBoxShadow: "0 0 0 1000px white inset",
  },
};

export default function RecruitmentSearchFromCondition() {
  const {
    searchCondition,
    setSearchCondition,
    setRecruitmentList,
    setIsEndList,
  } = useContext(recruitmentListContext);

  const defaultFormData = useMemo(() => createDefaultFormData(), []);

  const onSubmit = async (event) => {
    if (event) event.preventDefault();
    setIsEndList(false);
    const resetOffsetFormdata = { ...searchCondition, offset: 0 };

    try {
      const response = await BaseApi.get("project_list", { params: resetOffsetFormdata });
      const data = response?.data?.data || {};
      setRecruitmentList(data.project_list || []);

      if (data.next === 0) {
        setIsEndList(true);
      } else {
        setSearchCondition((prev) => ({
          ...prev,
          offset: data.next,
        }));
        setIsEndList(false);
      }
    } catch (err) {
      console.error("onSubmit error:", err);
    }
  };

  const handleChangeFormData = (newData) => {
    setIsEndList(true);
    setSearchCondition((prev) => ({ ...prev, ...newData }));
  };

  const handleReset = () => {
    setIsEndList(true);
    setSearchCondition(defaultFormData);
  };

  return (
    <Box component="form" onSubmit={onSubmit} noValidate>
      <Grid container alignItems="center">
        <ProjectIdField
          onChange={handleChangeFormData}
          value={searchCondition.project_id}
          classes={inputAutofillStyle}
        />
        <CostField
          onChange={handleChangeFormData}
          costMaxValue={searchCondition.cost_max}
          costMinValue={searchCondition.cost_min}
          classes={inputAutofillStyle}
        />
        <KeywordField
          onChange={handleChangeFormData}
          value={searchCondition.keyword}
          classes={inputAutofillStyle}
        />
        <DateField
          onChange={handleChangeFormData}
          dateFromValue={searchCondition.date_from}
          dateToValue={searchCondition.date_to}
          classes={inputAutofillStyle}
        />
        <ClosedRecruitmentField
          onChange={handleChangeFormData}
          value={searchCondition.close_check}
        />
        <CostNotSetField
          onChange={handleChangeFormData}
          value={searchCondition.cost_not_set}
          disabled={
            !(
              Boolean(searchCondition.cost_min) &&
              Boolean(searchCondition.cost_max)
            )
          }
        />
      </Grid>

      <Grid container>
        <Grid item xs={3} />
        <Grid item xs={6}>
          <RecruitmentConditionButton />
        </Grid>
        <Grid item xs={3}>
          <Box>
            <Button
              onClick={handleReset}
              sx={{ mt: { xs: "30px", sm: "40px" } }}
              color="inherit"
            >
              検索条件をリセット
            </Button>
          </Box>
        </Grid>
      </Grid>

      <RecruitmentList />
    </Box>
  );
}